import { render, staticRenderFns } from "./informationRequestDetail.vue?vue&type=template&id=165e1c83&scoped=true&"
import script from "./informationRequestDetail.vue?vue&type=script&lang=js&"
export * from "./informationRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./informationRequestDetail.vue?vue&type=style&index=0&id=165e1c83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165e1c83",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
